const features = [
  {
    id: 1,
    title: '科幻巨制 · 流浪地球系列',
    desc: '中国科幻电影的里程碑之作，郭帆导演倾力打造，震撼视觉特效与深刻人文思考的完美结合。',
    tag: '专题推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20scene%20with%20massive%20spaceship%20and%20planet%2C%20dramatic%20cosmic%20lighting%2C%20epic%20scale%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '经典港片 · 周星驰全集',
    desc: '从《大话西游》到《功夫》，星爷经典作品全收录，重温那些笑中带泪的港片黄金年代。',
    tag: '经典回顾',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Hong%20Kong%20street%20scene%20at%20night%2C%20neon%20signs%2C%20warm%20vintage%20tones%2C%20cinematic%20lighting%2C%201990s%20atmosphere%2C%20film%20noir%20style%2C%20no%20people%2C%20no%20text&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫崛起 · 高分动画精选',
    desc: '《哪吒》《大圣归来》《三体》等优秀国产动画，见证中国动画的华丽蜕变与无限可能。',
    tag: '国创精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20animation%20style%20landscape%20with%20traditional%20elements%2C%20vibrant%20colors%2C%20dreamy%20atmosphere%2C%20artistic%20composition%2C%20warm%20golden%20lighting%2C%20no%20people%2C%20no%20text&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑烧脑 · 高能反转合集',
    desc: '精选国内外高分悬疑片，层层反转烧脑不断，每一部都让你看到最后一秒大呼过瘾。',
    tag: '高分精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20dimly%20lit%20room%20with%20dramatic%20shadows%2C%20film%20noir%20atmosphere%2C%20detective%20vibe%2C%20warm%20amber%20light%20from%20a%20single%20lamp%2C%20cinematic%20composition%2C%20no%20people%2C%20no%20text&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '古装权谋 · 庆余年&琅琊榜',
    desc: '国产古装剧巅峰之作，精良制作与演技炸裂的演员阵容，权谋博弈中感受历史厚重感。',
    tag: '口碑神剧',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ancient%20palace%20architecture%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20historical%20atmosphere%2C%20cinematic%20composition%2C%20elegant%20style%2C%20no%20people%2C%20no%20text&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '纪录片精选 · 看见更大的世界',
    desc: 'BBC、国家地理、央视等顶级纪录片资源，自然、人文、历史，打开视野的窗口。',
    tag: '知识盛宴',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20nature%20landscape%20with%20dramatic%20mountains%20and%20golden%20sunset%20light%2C%20documentary%20style%2C%20epic%20scale%2C%20warm%20atmospheric%20tones%2C%20cinematic%20composition%2C%20no%20people%2C%20no%20text&width=800&height=450&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">精选专题策划，发现你的下一部好片</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}